import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from "react";
import { setDraggableCamId } from '../store/browse/actions';
import { elType, childOf } from '../utils';

// TODO
// finish functionality to drag panes for maps and webpages

const useDragPane = (ref: React.RefObject<HTMLElement>, cam: any) => {
  let element: elType = null;
  const dispatch = useDispatch();
  const [draggable, setDraggable] = useState(false);

  const onDragStart = (e: React.MouseEvent) => {
    fadeOut(e);
    cam && dispatch(setDraggableCamId(cam))
  };

  const fadeOut = (e: React.MouseEvent) => {
    element = ref.current;
    const elems = document.getElementsByClassName('fadeable');
    const elemsArray = Array.from(elems);

    elemsArray.map((elem: any) => {
      if (!childOf(e.currentTarget, elem)) elem.style.opacity = '0.5';
      return null;
    }, []);
  };

  const fadeIn = () => {
    const elems = document.getElementsByClassName('fadeable');
    const elemsArray = Array.from(elems);
    elemsArray.map((elem: any) => {
      return elem.style.opacity = '1'
    }, []);

    setDraggable(false);
    dispatch(setDraggableCamId(null))
  };

  const onDragLeave = (e: React.MouseEvent) => {
    if (!childOf(e.currentTarget, element)) {
      e.stopPropagation()
    }
  };

  const onMouseMove = (e: React.MouseEvent) => {
    if (!draggable) {
      e.stopPropagation();
      e.preventDefault();
      return false
    }
  };

  const onMouseDown = () => {
    setDraggable(true);
  }

  useEffect(() => {

  }, []);

  return {element, onMouseMove, onDragLeave, fadeIn, onDragStart, onMouseDown};
};

export default useDragPane;